module.exports = __webpack_public_path__ + "static/img/4-5.eef74e5e.png";